// ����������� ������ ������ ������ � ������������
import 'modern-normalize/modern-normalize.css';

// ������ ����������� ������ �� @fontsource
//import '@fontsource-variable/montserrat/wght.css';
//import '@fontsource-variable/montserrat/wght-italic.css';

// ����������� �������� ������ �������
import "@/styles/main.scss";

// ������ ������� �� �������
import detectTouchDevice from "@/core/detectTouchDevice.js";
import processLinks from "@/core/processLinks.js";
import applyIcons from "@/core/applyIcons.js";
import applyWidgets from "@/core/applyWidgets.js";
import calcScrollbarWidth from "@/core/calcScrollbarWidth.js";
import onDomReady from "@/utils/onDomReady.js";

// ���������� ���� ����� ������ �������� DOM
onDomReady(function () {
    detectTouchDevice(); // ����������� ��������� � ���������� ��������
    calcScrollbarWidth(); // ������ ������ ������ ���������
    processLinks(); // ��������� ������
    applyWidgets(); // ���������� ��������
    applyIcons(); // ���������� ������   
});
